import { useState } from "react";
import { useAuth } from "../auth";

export default function Login() {
  const { login } = useAuth();
  const [identifier, setIdentifier] = useState("");
  const [pwd, setPwd] = useState("");
  const [err, setErr] = useState<string | null>(null);
  const [busy, setBusy] = useState(false);

  async function submit(e: React.FormEvent) {
    e.preventDefault();
    setErr(null);
    setBusy(true);
    try {
      await login(identifier.trim().toUpperCase(), pwd);
    } catch (e: unknown) {
      setErr(e instanceof Error ? e.message : "Erreur");
    } finally {
      setBusy(false);
    }
  }

  return (
    <div className="login-screen">
    <div className="login-card">
      <img src="/icon.svg" alt="e-flux" className="login-logo" />
      <p className="sub">Groupe LAWKORN Investment</p>
      <form onSubmit={submit}>
        <label>Identifiant</label>
        <input
          autoComplete="username"
          inputMode="text"
          autoCapitalize="characters"
          value={identifier}
          onChange={(e) => setIdentifier(e.target.value)}
          placeholder="ex. BF"
          maxLength={8}
          required
        />
        <label>Mot de passe</label>
        <input
          type="password"
          autoComplete="current-password"
          value={pwd}
          onChange={(e) => setPwd(e.target.value)}
          required
        />
        {err ? <div className="error">{err}</div> : null}
        <div style={{ height: 20 }} />
        <button className="btn btn-primary full" type="submit" disabled={busy}>
          {busy ? "Connexion…" : "Se connecter"}
        </button>
      </form>
    </div>
    </div>
  );
}
